<template>
    <div id="listDetail">
        <my-header></my-header>
        <img style="margin-top: 70px;" src="../../assets/images/inviteList/banner.png" alt="" class="banner-image">
        <div class="main-container mainCon">
            <p class="location">您当前的位置：招标公告详情</p>
            <div class="detailCon">
                <div >
                    <h2>“ {{ detailData.purchaseItemName }} ”工程   招标公告</h2>
                    <img style="margin-top: 12px;" src="../../assets/images/invitemanage/titbg.png"/>
                </div>
                <section class="detailList">
                    <h3>一、招标公司及类别</h3>
                    <!-- <ul class="firstList" >
                        <li>
                            <em>招标编号：</em><span> </span>
                        </li>
                        <li>
                            <em>项目名称：</em><span>{{ detailData.projectName }}</span>
                        </li>
                        <li>
                            <em>招标内容：</em><span>{{ detailData.purchaseItemName }}</span>
                        </li>
                        <li>
                            <em>招标类别：</em><span>{{ getClass(detailData.purchaseClassification) }}</span>
                        </li>
                        <li>
                            <em>其他要求：</em><span>{{ detailData.otherRequirements }}</span>
                        </li>
                        <li>
                            <em>招标联系人：</em><span>{{ detailData.tenderContactPerson }}</span>
                        </li>
                        <li>
                            <em>招标经办人：</em><span>{{ detailData.tenderAgent }}</span>
                        </li>
                        <li>
                            <em>报名截止时间：</em><span>{{ detailData.signDeadline }}</span>
                        </li>
                    </ul> -->
                    <el-input  v-model="detailData.tenderIntroduction"
                               readonly
                               autosize
                               class="textBorder"
                               type="textarea"></el-input>
                    <h3>二、招标项目概况：</h3>
                    <el-input  v-model="detailData.tenderProjectIntroduction"
                               readonly
                               autosize
                               class="textBorder"
                               type="textarea"></el-input>
                    <h3>三、投标单位入围要求：</h3>
                    <el-input  v-model="detailData.tenderRequirements"
                               readonly
                               autosize
                               class="textBorder"
                               type="textarea"></el-input>
                    <h3>四、投标报名条件及提交材料：</h3>
                    <el-input  v-model="detailData.otherRequirements"
                               readonly
                               autosize
                               class="textBorder"
                               type="textarea"></el-input>
                    <h3>五、在线报名和投标资料提交截止日期：</h3>
                    <el-input  v-model="detailData.signDeadline"
                               readonly
                               autosize
                               class="textBorder"
                               type="textarea"></el-input>
                    <h3>六、招标联系人及地址：</h3>
                    <el-input  v-model="detailData.tenderContactPerson"
                               readonly
                               autosize
                               class="textBorder"
                               type="textarea"></el-input>
                    <h3>七、监察投诉电话：</h3>
                    <el-input  v-model="detailData.tenderSupervise"
                               readonly
                               autosize
                               class="textBorder"
                               type="textarea"></el-input>
                    <div style="margin-top: 20px;" v-if="$root.isLogin">
                        <el-button style="color:#000000;padding: 10px 40px;font-size: 14px;background: #cfcfcf;" @click="cancel">取 消</el-button>
                        <span v-if="canSubmit">
                            <el-button type="primary" style="padding: 10px 40px;font-size: 14px;"  @click="showDialog" >报 名</el-button>
                        </span>
                        <span v-else>
                            <el-button v-if="detailData.isSigned!=2" style="padding: 10px 40px;font-size: 14px;background: #cfcfcf;cursor:not-allowed" >已报名</el-button>
                        </span>
                    </div>
                </section>
            </div>
        </div>
        <el-dialog
            title= '请选择供方分类'
            :visible.sync="dialogClassVisible"
            top="5vh"
            width="30%">
            <el-form :model="formData"
                     :rules="formRules"
                     ref="classForm"
                     label-width="120px">
                <el-form-item label="供方分类：" prop="classType" >
                    <el-select size="medium" v-model="formData.classType"
                               placeholder="请选择" @change="changeType">
                        <el-option
                            v-for="item in classOptions"
                            :key="item.categoryId"
                            :label="item.categoryName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit" >报 名</el-button>
             </span>
        </el-dialog>
        <el-dialog
            title="选择标段"
            :visible.sync="dialogSectionVisible"
             width="60%"
            @close="dialogSectionVisible=false">
            <el-checkbox-group 
                v-model="checkSections"
                >
                <el-checkbox v-for="item in checkSectionList" :label="item.id" :key="item.id">{{item.sectionName}}</el-checkbox>
            </el-checkbox-group>
            <div slot="footer" style="text-align:center;" >
                <el-button type="default" @click="dialogSectionVisible=false" size="mini">取 消</el-button>
                <el-button type="primary" @click="submitSection()" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script type="text/babel">
    import MyHeader from '../common/Header.vue'
    import MyFooter from '../common/Footer.vue'
    export default {
        name: 'listDetail',
        data() {
            return {
                messageId: '',
                pkuSupplierSplitInfoId:'',
                detailData: {},//详情信息
                checkSections:[],
                checkSectionList:[],
                dialogClassVisible: false,//弹层
                dialogSectionVisible: false,//弹层
                formData: {
                    classType:'',//供方分类
                },
                formRules: {
                    classType: [
                        {required: true, message: '请选择供方分类'}
                    ]
                },
                classOptions: [],
                pkuId: '',//选中的供方分类id
                canSubmit: true,//是否可以报名
            }
        },
        components: {
            MyHeader,
            MyFooter
        },
        created(){
            this.$root.activeIndex = 'invite';
            this.messageId = this.$route.params.id;
            this.getData();
        },
        methods: {
            getData(){
                this.$root.getHttp('/v1/outerformflow/public/getBidDetial/'+this.messageId+"/"+window.sessionStorage.getItem('loginId'),(res) => {
                    this.detailData = res.data.data;
                    this.detailData.tenderIntroduction = this.formatTextareaToRN(this.detailData.tenderIntroduction);
                    this.canSubmit = this.detailData.isSigned==0?true:false;
                    /* if(this.$root.isLogin){
                        this.$root.postHttp('v1/pkuSupplierSplitInfo/getCategory',{
                            supplierId: window.sessionStorage.getItem('loginId'),
                            tenderingAreaId: window.sessionStorage.getItem('tenderingAreaId'),
                            formId: this.detailData.formId
                        }, response => {
                            this.classOptions = response.data.data || [];
                            if(!response.data.data){
                                this.canSubmit = false;
                            }
                        })
                    } */
                });
            },
            getClass(code){
                if(code == 0){
                    return '设计类';
                } else if(code == 1){
                    return '工程类';
                } else if(code == 2){
                    return '营销类';
                }
            },
            changeType(val){//改变类型
//                console.log(66,val)
                this.pkuId = val;
            },
            showDialog(){
                //this.dialogClassVisible = true;
                let that = this;
                that.$confirm('确定报名吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.$root.postHttp('/v1/outerformflow/outerGetSectionAndSign',{
                            bidPlanVO: this.detailData,
                            pkuSupplierSplitInfo: {
                                supplierId: window.sessionStorage.getItem('loginId')
                            }
                            },res => {
                                if(res.data.data.isSingleSection==0){
                                    that.pkuSupplierSplitInfoId = res.data.data.pkuSupplierSplitInfo.id;
                                    that.dialogSectionVisible = true;
                                    that.checkSectionList = res.data.data.bidSectionList;
                                }else{
                                    that.$message.success('报名成功');
                                    //that.canSubmit = false; 
                                    this.cancel();
                                }
                            })
                        }
                    }
                });
            },
            submitSection(){
                let tempList=[];
                console.log(111,this.checkSections)
                this.checkSections.forEach((item,index)=>{
                    tempList.push(this.checkSectionList.find((element) => (element.id == item)));
                })
                this.$root.postHttp('v1/outerformflow/apply',{
                    bidPlanVO: this.detailData,
                    pkuSupplierSplitInfo: {
                        id: this.pkuSupplierSplitInfoId
                    },
                    bidSectionList:tempList
                },res => {
                    this.$message.success('报名成功');
                    this.dialogSectionVisible = false;
                    this.cancel();
                    //this.canSubmit = false;
                }) 
            },
            /*处理输入框中的换行*/
            formatTextareaToRN(strValue){
                if(strValue=='' || strValue==null || strValue==" "){
                    return ''
                }else{
                    return strValue.replace(/<br\s*\/?>/gi,"\r\n");
                }
            },
            submit(){//关闭弹层,并报名
                this.$refs.classForm.validate( valid => {
                    if(valid){
                        this.$root.postHttp('v1/outerformflow/apply',{
                            bidPlanVO: this.detailData,
                            pkuSupplierSplitInfo: {
                                id: this.pkuId
                            }
                        },res => {
                            this.$message.success('报名成功');
                            this.dialogClassVisible = false;
                            //this.canSubmit = false;
                        })

                    } else {
                        this.$alert('必须选择分类再进行报名', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        });
                    }
                })
            },
            cancel(){
                this.$router.push('/invite-list');
            },
        }
    }
</script>
<style lang="scss">
    @import '../../assets/_var.scss';
    #listDetail {
        background-color: $--primary-fill-color;
        & .head-top{
            background: #fff;
        }
        & .head-right {
            color: $--text-color-light;
            & .login {
                background: url('../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
            }
            & .register {
                background: url('../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
            }
            & .line {
                background: $--text-color-light;
            }
            & .help {
                background: url('../../assets/images/topBar2/icon05.png') no-repeat;
            }
            & .standard {
                background: url('../../assets/images/topBar1/standard2.png') no-repeat 5px center / 16px 16px;
            }
            & .wechat {
                background: url('../../assets/images/topBar2/icon06.png') no-repeat;
            }
        }
        .banner-image {
            min-width: 1300px;
            height: 140px;
        }
        & .mainCon {
            margin-top: 15px;
            padding-bottom: 50px;
            min-height: 60vh;
        }
        .location {
            padding-left: 15px;
            text-align: left;
            font-size: 12px;
            line-height: 42px;
            color: $--text-color-light;
            background: url('../../assets/images/inviteList/location.png') no-repeat left center;
        }
        .detailCon {
            padding: 70px 70px 90px;
            background: #fff;
            .detailList {
                /*margin-top: 20px;*/
                h3 {
                    margin-top: 30px;
                    padding-left: 75px;
                    padding-top: 23px;
                    text-align: left;
                    font-size: 16px;
                    line-height: 26px;
                    background: url('../../assets/images/invitemanage/titbg01.png') no-repeat;
                }
                h3:nth-of-type(2){
                    background: url('../../assets/images/invitemanage/titbg02.png') no-repeat;
                }
                h3:nth-of-type(3){
                    background: url('../../assets/images/invitemanage/titbg03.png') no-repeat;
                }
                h3:nth-of-type(4){
                    background: url('../../assets/images/invitemanage/titbg04.png') no-repeat;
                }
                h3:nth-of-type(5){
                    background: url('../../assets/images/invitemanage/titbg05.png') no-repeat;
                }
                h3:nth-of-type(6){
                    background: url('../../assets/images/invitemanage/titbg06.png') no-repeat;
                }
                h3:nth-of-type(7){
                    background: url('../../assets/images/invitemanage/titbg07.png') no-repeat;
                }
                h3:nth-of-type(8){
                    background: url('../../assets/images/invitemanage/titbg08.png') no-repeat;
                }
                h3:nth-of-type(9){
                    background: url('../../assets/images/invitemanage/titbg09.png') no-repeat;
                }
                h3:nth-of-type(10){
                    background: url('../../assets/images/invitemanage/titbg10.png') no-repeat;
                }

                .firstList {
                    margin-top: 30px;
                    padding: 0 65px;
                    li {
                        text-align: left;
                        /*margin-top: 20px;*/
                        font-size: 14px;
                        line-height: 48px;
                        em {
                            color: $--text-color-lighter;
                            font-style: normal;
                            padding-left: 25px;
                            background: url('../../assets/images/invitemanage/listIcon.png') no-repeat;
                        }
                        span {
                            color: $--text-color-light;
                        }
                    }
                }
                p {
                    margin-top: 25px;
                    padding: 0 65px;
                    text-align: left;
                    font-size: 14px;
                    line-height: 34px;
                    color: $--text-color-light;
                }
                .email {
                    span {
                        display: inline-block;
                        margin-right: 5px;
                        width: 32px;
                        height: 32px;
                        vertical-align: middle;
                        background: url('../../assets/images/invitemanage/icon06.png') no-repeat;
                    }
                    strong {
                        color: $--text-color;
                    }
                }
            }
        }
        .textBorder {
            .el-textarea__inner {
                margin-top: 15px;
                padding: 0px 75px;
                border: none;
            }
        }
        .el-tag {
            padding: 0px 40px;
            cursor: not-allowed;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/invite/ListDetail.vue